import { RELATORIO_VEICULAR_ACCESS } from '../constants/modules';
import { isUsuarioUsoMuto } from '../utils';
import { isRoleAuditoriaNsir } from './auditoriaNsirPermission';
import { hasModuleConfiguration, isViniciusAdmin } from './moduleConfigurationPermission';

/**
 * Quem pode acessar /v2/relatorio-veiculo (menu + tela).
 * Requer module configuration RELATORIO_VEICULAR_ACCESS vinculada ao userId logado
 * (ou e-mail vinicius_admin).
 */
export function canViewVeiculoReport({ authData, userRole, moduleConfigurations }) {
  if (isViniciusAdmin(authData)) return true;
  if (!authData?.id) return false;

  const role = userRole ?? authData.role;
  if (isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(role)) {
    return false;
  }

  return hasModuleConfiguration(moduleConfigurations, authData, RELATORIO_VEICULAR_ACCESS);
}
